import { render, staticRenderFns } from "./receiptPhoto.vue?vue&type=template&id=f27b2a2e&scoped=true&"
import script from "./receiptPhoto.vue?vue&type=script&lang=ts&"
export * from "./receiptPhoto.vue?vue&type=script&lang=ts&"
import style0 from "./receiptPhoto.vue?vue&type=style&index=0&id=f27b2a2e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f27b2a2e",
  null
  
)

export default component.exports